export default __webpack_public_path__ + "static/media/mobile_placeholder.cf26048a.jpg";